import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {SharedPreference} from '../shared-preference/shared-perference';
import {profile} from '../inventory/route';
import {Role} from '../model/role';
import {AuthenticationService} from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SignupService implements CanActivate{

  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (!SharedPreference.getUser()) {
      this.authenticationService.onLogout(false);
      return false;
    }

    if (SharedPreference.getUser() && SharedPreference.getUser().isRequireChangePassword) {
      this.router.navigate([profile]);
      return false;
    } else {
      return (Role.hasAdminRole(SharedPreference.getUser()) ||
        Role.hasVersitaSystem(SharedPreference.getUser()) ||
       Role.hasVersitaAdmin(SharedPreference.getUser()));
    }

  }

}
